/*
 * Copyright (c) 2021 SARL SIGMA POLYNESIA
 */

import { useIntl } from 'react-intl'
import { fetchRoles } from '../../../role/lib/roleAPIClient'
import { useQuery } from '@tanstack/react-query'
import { useMemo } from 'react'
import { getHalEmbedded } from '@jalik/hal'
import { parseNumber } from '@jalik/form-parser'
import FormField from '../../../../client/js/components/form/fields/FormField'
import { Select, SelectProps } from '@mantine/core'

export type RoleFieldProps = Omit<SelectProps, 'data'>

function RoleField (props: RoleFieldProps) {
  const { name = 'roleId', ...others } = props
  const intl = useIntl()

  const rolesQuery = useQuery({
    enabled: true,
    queryKey: ['roles'],
    queryFn: () => fetchRoles({ limit: 100 })
  })
  const roles = useMemo(() => (
    (rolesQuery.data != null ? getHalEmbedded(rolesQuery.data)?.roles : null) || []
  ), [rolesQuery.data])

  return (
    <FormField
      label={intl.formatMessage({
        id: 'role',
        defaultMessage: 'Rôle'
      })}
      {...others}
      name={name}
      parser={parseNumber}
      render={Select}
      data={[
        {
          value: '',
          label: intl.formatMessage({
            id: 'no_role',
            defaultMessage: 'Aucun rôle'
          })
        },
        ...roles.map((item) => ({
          value: String(item.id),
          label: item.name
        }))
      ]}
    />
  )
}

export default RoleField
